
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19","height":"19"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Ellipse_98","data-name":"Ellipse 98","d":"M512.069 278.094a9.5 9.5 0 11-9.5 9.5 9.5 9.5 0 019.5-9.5z","transform":"translate(-502.569 -278.094)","fill":"#f0f1f3"}}),_c('path',{attrs:{"id":"Path_6481","data-name":"Path 6481","d":"M5.999 8.5h7.538a.5.5 0 110 1H5.999a.5.5 0 110-1z","fill":"#6a7685","stroke":"#6b7786","stroke-width":".2"}})])
          )
        }
      }
    